export default __webpack_public_path__ + "static/media/funds.8c7abbcb.svg";